import { render } from "./ElementDatasets.vue?vue&type=template&id=2161b8b0&ts=true"
import script from "./ElementDatasets.vue?vue&type=script&lang=ts"
export * from "./ElementDatasets.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__